export default __webpack_public_path__ + "static/media/jaguar.24c5a8f4.png";